import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Spinner, Container, Alert } from 'react-bootstrap';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading, hasAccess, isSheikh, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  if (!isAuthenticated) return <Navigate to="/login" />;

  if (isSheikh && !location.pathname.startsWith('/qna')) {
    return <Navigate to="/qna" replace />;
  }

  if (!hasAccess) {
    return (
      <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <Alert variant="danger" className="text-center" style={{ maxWidth: 400 }}>
          <i className="bi bi-shield-x fs-1 d-block mb-3"></i>
          <h5>غير مصرح بالدخول</h5>
          <p className="text-muted small mb-3">
            حسابك ({user?.email}) لا يملك صلاحية الوصول إلى لوحة التحكم.
          </p>
          <button className="btn btn-outline-danger btn-sm" onClick={() => { localStorage.clear(); window.location.href = '/dash/login'; }}>
            <i className="bi bi-box-arrow-left ms-1"></i>
            تسجيل الخروج
          </button>
        </Alert>
      </Container>
    );
  }

  return children;
};

export default PrivateRoute;
